
export const environment = {
  production: false,
  base_url: 'http://localhost:2300/',
  itinerary_client_id: '4413f350648d6e93540266e95084b299',
  itinerary_client_secret_key: 'e076ab30c1503580d420ae8cb0074be49511c0a5728c3df670cac50774fc42c8',
  //itinerary_base_url: 'https://itinerary.buupass.com/',
  itinerary_base_proxy_url: 'https://itinerary.dev.buupass.com/',
  itinerary_base_url: 'https://itinerary.dev.buupass.com/',
  corperate_base_url: 'https://corporateapi.dev.buupass.com',
  rbac_base_url: 'https://corporateapi.dev.buupass.com',
  hotels_base_url: 'https://hotelsapi.dev.buupass.com',
  //hotels_base_url: 'https://dev.itinerary.buupass.com',
}

